var React = require('react');

function TikTok (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#F8FAFC","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"M21 8v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5Z","key":0}),React.createElement("path",{"stroke":"#F8FAFC","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"M10 12a3 3 0 1 0 3 3V6c.333 1 1.6 3 4 3","key":1})]);
}

TikTok.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TikTok;

TikTok.default = TikTok;
